type FormatBytesProps = {
  bytes: number;
  isSufix?: boolean;
  decimals?: number;
};

const formatBytes = ({ bytes, decimals = 2, isSufix = true }: FormatBytesProps) => {
  if (bytes === 0) return isSufix ? '0 Bytes' : 0;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const calculatedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

  return isSufix ? `${calculatedSize} ${sizes[i]}` : calculatedSize;
};

export default formatBytes;
